




























import { defineComponent } from "@vue/composition-api";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { isMobile, isMacOS } from "@/lib/browserUtils";
import emitter from "@/lib/emitter";
import { PostFileData } from "@/types";
import { EVENTS } from "@/const";
import BaseIcon from "@/components/BaseIcon";
import PostFileList from "@/components/PostFileList";
import PostFilesArea from "../PostFilesArea";
import PreviewSetButton from "../PreviewSetButton";

export default defineComponent({
  name: "MediaPostEditView",
  components: { PreviewSetButton, PostFileList, BaseIcon, PostFilesArea },
  props: {
    fileList: { type: Array as () => PostFileData[], required: true },
    postData: { type: Object as () => ContentSet, required: true },
  },
  data() {
    return {
      showPublicButton: false,
      isFixSize: !(isMobile() || isMacOS()),
    };
  },
  created() {
    const onPriceChanged = ({
      recurringLevel,
      oneTimePackage,
    }: {
      recurringLevel: SubscriptionLevel | null;
      oneTimePackage: PaymentPackage | null;
    }) => {
      this.showPublicButton =
        this.postData.type !== ContentFeedTypeEnum.EVENT &&
        (recurringLevel?.pricePackage?.amount ?? oneTimePackage?.amount ?? 0) > 0;
      this.$emit("updatePostPrice", { recurringLevel, oneTimePackage });
    };
    emitter.on<any>(EVENTS.CONTENT_FEED_PRICE_CHANGED, onPriceChanged);
    this.$once("hook:beforeDestroy", () => emitter.off<any>(EVENTS.CONTENT_FEED_PRICE_CHANGED, onPriceChanged));
    emitter.on<any>(EVENTS.CONTENT_FEED_PRICE_LOADED, onPriceChanged);
    this.$once("hook:beforeDestroy", () => emitter.off<any>(EVENTS.CONTENT_FEED_PRICE_LOADED, onPriceChanged));
  },
});
